import React, { useState, useRef } from "react";
import { observer } from "mobx-react-lite";
import { Divider, Flex } from "@fluentui/react-northstar";
import TasksBoard from "./TasksBoard";
import TaskDetails from "./taskDetails/TaskDetails";
import { addWeeks, startOfWeek, endOfWeek } from "date-fns";
import { DateRange } from "shared/models/DateRange";
import { useStore } from "stores/Stores";
import { useResize } from "ecom-teams-apps-core";
import { constants } from "shared/constants";
import TaskBoardTopBar from "./topBar/TaskBoardTopBar";
import ValidationDialog from "modals/ValidationDialog";
import { CloseTaskEventSource } from "appilication-insights/events/CloseTask/CloseTaskEventSource";
import { CloseTaskEvent } from "appilication-insights/events/CloseTask/CloseTaskEvent";
import { trackEvent } from "appilication-insights/ApplicationInsightsUtils";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";

const TasksContainer: React.FC = observer(() => {
    const { tasksStore } = useStore();
    const [chosenTaskId, setChosenTaskId] = useState(0);
    const [dateRange, setDateRange] = useState<DateRange>({
        start: startOfWeek(new Date(), { weekStartsOn: 1 }),
        end: endOfWeek(new Date(), { weekStartsOn: 1 }),
    });

    const windowRef = useRef(document.body);
    const [windowWidth] = useResize(windowRef);
    const isMobile = windowWidth < constants.mediumDeviceWidthPx;
    const appInsightsContext = useAppInsightsContext();

    const trackCloseTask = (source: CloseTaskEventSource) => {
        const event = new CloseTaskEvent(source);
        trackEvent(appInsightsContext, event, event.getCustomProperties());
    };

    return (
        <>
            <Flex style={isMobile ? { overflow: "hidden", height: "100%" } : { height: "calc(100vh - 67px)" }}>
                <Flex.Item grow={1}>
                    <Flex style={{ overflow: "hidden" }} column>
                        <TaskBoardTopBar
                            range={dateRange}
                            disabled={tasksStore.loadTasksRequestStatus.isPending}
                            onBackwardClick={() => {
                                setDateRange({
                                    start: addWeeks(dateRange.start, -1),
                                    end: addWeeks(dateRange.end, -1),
                                });
                                setChosenTaskId(0);
                                tasksStore.clearFilters();
                            }}
                            onForwardClick={() => {
                                setDateRange({ start: addWeeks(dateRange.start, 1), end: addWeeks(dateRange.end, 1) });
                                setChosenTaskId(0);
                                tasksStore.clearFilters();
                            }}
                            isMobile={isMobile}
                        />
                        <Divider style={{ padding: "0" }} />
                        <TasksBoard
                            isMobile={isMobile}
                            dateRange={dateRange}
                            chosenTaskId={chosenTaskId}
                            onShowTaskDetails={(taskId: number) => setChosenTaskId(taskId)}
                            onTaskClosed={trackCloseTask}
                        />
                    </Flex>
                </Flex.Item>
                {chosenTaskId !== 0 ? (
                    <Flex.Item shrink={1}>
                        <TaskDetails
                            dateRange={dateRange}
                            taskId={chosenTaskId}
                            isMobile={isMobile}
                            onCancel={() => setChosenTaskId(0)}
                            onTaskClosed={trackCloseTask}
                        />
                    </Flex.Item>
                ) : (
                    <div></div>
                )}
            </Flex>
            <ValidationDialog />
        </>
    );
});

export default TasksContainer;
